var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVzyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.272 0.000591507H20.9321C20.4705 0.000591507 19.9135 0.377892 19.6939 0.839169L15.0465 10.604C14.9399 10.8388 14.7422 10.9583 14.467 10.9796C14.1687 10.9689 14.0018 10.8175 13.8887 10.607L9.24012 0.838578C9.02053 0.377301 8.46357 0 8.00191 0H0.661998C0.0849151 0 -0.162491 0.47133 0.112142 1.04793L10.6364 23.1608C10.856 23.6221 11.4129 23.9994 11.8746 23.9994H17.0595C17.5211 23.9994 18.0781 23.6221 18.2977 23.1608L28.8219 1.04793C29.0959 0.47133 28.8485 0 28.272 0",
    fill: "#F05A25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0462 0.000976562H30.8676H25.3619C24.7996 0.000976562 24.1616 0.375912 23.9437 0.83364L21.4892 5.99048C21.2418 6.51089 21.5614 6.93669 22.2001 6.93669H26.5522C26.7747 6.92841 26.9683 7.04077 27.0831 7.20872C27.2044 7.38673 27.2382 7.62624 27.1429 7.82612L19.9438 22.9519C19.6698 23.5285 19.9172 23.9998 20.4937 23.9998H28.6723H33.2818C33.8441 23.9998 34.4822 23.6249 34.7 23.1671L37.1545 18.0103C37.4019 17.4899 37.0823 17.0641 36.4437 17.0641H32.98C32.7308 17.0653 32.5651 16.9405 32.4355 16.7601C32.3467 16.5957 32.2958 16.3869 32.4005 16.167L39.596 1.0489C39.8701 0.472307 39.6227 0.000976562 39.0462 0.000976562Z",
    fill: "url(#paint0_linear_452_4048)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.452 0.000591507H48.1121C47.6505 0.000591507 47.0935 0.377892 46.8739 0.839169L44.2625 6.326C44.1376 6.56255 43.9465 6.68792 43.6843 6.70093C43.4404 6.69679 43.2309 6.58975 43.1066 6.32836L40.494 0.839169C40.2744 0.377892 39.7175 0.000591507 39.2558 0.000591507H31.9159C31.3388 0.000591507 31.0914 0.471922 31.366 1.04852L38.7432 16.5486C38.8415 16.768 38.8989 16.9915 38.9113 17.221C38.9362 17.4564 38.8604 17.6722 38.7432 17.9188L36.3491 22.9497C36.075 23.5257 36.323 24 36.9001 24H44.24C44.7017 24 45.2587 23.6227 45.4783 23.1614L56.0019 1.04793C56.2759 0.47133 56.0285 0 55.452 0",
    fill: "url(#paint1_linear_452_4048)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_4048",
    x1: 18.0409,
    y1: 4.45703,
    x2: 32.4289,
    y2: 13.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F05A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BF425B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#993184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#82269E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A22A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_452_4048",
    x1: 29.6236,
    y1: 4.03085,
    x2: 50.3641,
    y2: 14.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B03C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#AC3A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#852D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7629A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6E2FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#583FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#345ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVzyLogo);
export default __webpack_public_path__ + "static/media/vzy-logo.a762895e11601b7ab2f988bf07fd00ed.svg";
export { ForwardRef as ReactComponent };